import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import thunk from 'redux-thunk'

import reducers from './reducers'

const store = configureStore({
  reducer: reducers,
  middleware: [logger, thunk],
})

export const useSelector = useReduxSelector

export const useDispatch = () => useReduxDispatch()

export default store

